(ns motorsaif.web.online-state
  (:require
   [re-frame.core :as rf]
   [reagent.core :as r]
   [taoensso.encore :as encore]))

(def *focused (atom true))
(defn on-visibility-change []
  (let [hidden? (= (.-visibilityState js/document) "hidden")]
    (if hidden?
      (reset! *focused false)
      (reset! *focused true))))

(def *is-idle (atom nil))
(def *idle-timeout (atom nil))
(def idle-ms (encore/ms :mins 1))

(def *state (r/atom :online))


(defn sync-online-state []
  (cond
    (= @*focused false)
    (reset! *state :busy)
    (= @*is-idle true)
    (reset! *state :idle)
    (or
     (= @*is-idle false)
     (= @*focused true))
    (reset! *state :online))

    (rf/dispatch [:sente-send :online/state-update @*state]))

;; Extra precaution, sync every minute
(defonce sync-online-interval
  (js/setInterval
   (fn []
     (sync-online-state))
   (encore/ms :mins 1)))

(defn online-state-watch [_ _ _ _]
  (sync-online-state))

(defn reset-idle-timer []
  (when @*idle-timeout
    (js/clearTimeout @*idle-timeout))

  (when @*is-idle
    (reset! *is-idle false))

  (reset! *idle-timeout
          (js/setTimeout
           (fn on-idle []
             (reset! *is-idle true))
           idle-ms)))


(defn init! []
  (reset-idle-timer)
  (doseq [event ["mousemove" "keydown" "mousedown" "touchstart"]]
    (.addEventListener js/window event reset-idle-timer true))
  ;; Tab not focused
  (.addEventListener js/document "visibilitychange" on-visibility-change)
  (add-watch *is-idle :is-idle online-state-watch)
  (add-watch *focused :is-focused online-state-watch)
  )
